<template>
  <div class="cursor-pointer group relative bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-2xl transition-all duration-500 border border-blog-gold flex flex-col h-full">
    <div class="absolute top-4 left-4 z-10 flex gap-2">
      <span v-for="tag in post.getTags().slice(0, 2)" :key="tag" 
            class="bg-blog-beige backdrop-blur-md text-blog-red text-[10px] font-bold px-3 py-1 rounded-full shadow-sm uppercase">
        {{ tag }}
      </span>
    </div>

    <div class="relative aspect-[16/10] overflow-hidden">
      <img :src="post.getPhoto()" :alt="post.title" 
           class="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700" />
      <div class="absolute inset-0 bg-gradient-to-t from-secondary/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity"></div>
    </div>

    <div class="p-6 flex flex-col flex-grow">
      <div class="flex items-center gap-3 mb-4 text-xs text-gray-400">
        <span class="flex items-center text-blog-old-red gap-1"><i class="pi pi-calendar"></i> {{ post.getUpdatedDate() }}</span>
        <span class="w-1 h-1 bg-gray-300 rounded-full"></span>
        <span class="flex items-center text-blog-old-red gap-1"><i class="pi pi-clock"></i> {{ post.getReadingTime() }} {{ translate('min read') }}</span>
      </div>

      <h3 class="text-xl font-bold text-blog-orange mb-3 group-hover:text-carrot transition-colors line-clamp-2 leading-tight">
        {{ post.title }}
      </h3>

      <p class="text-blog-old-red text-sm line-clamp-3 mb-6 flex-grow leading-relaxed">
        {{ post.getShortenedText() }}
      </p>

      <div class="flex items-center justify-between mt-auto pt-4 border-t border-blog-gold">
        <div class="flex items-center gap-2">
          <div class="w-8 h-8 rounded-full bg-carrot/10 flex items-center justify-center text-carrot">
            <i class="pi pi-user text-xs"></i>
          </div>
          <span class="text-xs font-bold text-blog-old-red uppercase tracking-tighter">{{ post.getAuthorName() }}</span>
        </div>
        <i class="pi pi-arrow-up-right text-carrot group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform"></i>
      </div>
    </div>
  </div>
</template>

<script setup>
import { translate } from '@/composables/translate';
import { computed, defineProps } from 'vue';

const props = defineProps({ post: { type: Object, required: true } });
const post = computed(() => props.post);
</script>